export default "__VITE_ASSET__C6x_DT1N__"